import { FC } from 'react';
import { FiZap } from 'react-icons/fi';
import { UserRole } from './ActionsPanel';

interface AssistantCardProps {
  role: UserRole;
  firstName: string;
  greeting: string;
}

const AssistantCard: FC<AssistantCardProps> = ({ role, firstName, greeting }) => {
  return (
    <div className="mb-6 p-6 bg-white rounded-lg shadow-sm">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
        <div>
          <h2 className="text-2xl font-bold text-slate-700 flex items-center">
            {greeting}, {firstName}!
            <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-700">
              <FiZap size={14} className="text-slate-600" />
              <span className="ml-1">{role}</span>
            </span>
          </h2>
        </div>
      </div>
      
      <div className="text-slate-600">
        <p>
          {role === 'CEO' 
            ? 'Ready to drive strategic growth and operational excellence across your institution.'
            : role === 'VP of Lending'
              ? 'Your lending portfolio is performing well. Review key opportunities and campaigns below.'
              : 'Focus on member engagement and relationship building activities for optimal results.'
          }
        </p>
      </div>
    </div>
  );
};

export default AssistantCard;